import { render, staticRenderFns } from "./dueDateIndex.vue?vue&type=template&id=22f3b2d3&"
import script from "./dueDateIndex.vue?vue&type=script&lang=js&"
export * from "./dueDateIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports